import { fun, baseData, getLan } from '../js/common.js'
//向位置服务器获取信息
function getPosMes(obj) {
    var command = obj.server === undefined ? 'query-hlr' : 'query-group-srv';
    var content = obj.server === undefined ? '<oem-customer-id>' + obj.oem + '</oem-customer-id>' : '<server-group-id>' + obj.server + '</server-group-id>';
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<command>' + command + '</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<server-type>user</server-type>' + content +
        '</content>' +
        '</envelope>';
    return xml;
};
//登录
function login(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<command>login</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '<type>1</type>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<account>' + obj.userName + '</account>' +
    //     '<auth-type>0</auth-type>' +
    //     '<password>' + obj.userPwd + '</password>' +
    //     '</content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            command: 'login',
            client: {
                oem: obj.oem
            }
        },
        content: {
            account: obj.userName,
            'auth-type': 0,
            password: obj.userPwd
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
};

function getPwdByPhone(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<command>reset-password</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<account>' + obj.val + '</account>' +
        '<auth-code>' + obj.code + '</auth-code>' +
        '<password>' + obj.pwd + '</password>' +
        '</content>' +
        '</envelope>';
    return xml;
};

function getPwdByEmail(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<command>apply-password-reset</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '<type>1</type>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<apply-way>link-email</apply-way>' +
    //     '<account>' + obj.email + '</account>' +
    //     '</content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            command: 'apply-password-reset',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'apply-way': 'link-email',
            account: obj.email
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
};

function getPwdByEmails(obj) {
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            command: 'reset-password',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'auth-code': obj.code,
            account: obj.email,
            password: obj.pwd
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
};

function getPwdByPhoneCode(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<command>apply-password-reset</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '<app>' + obj.app + '</app>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<apply-way>' + obj.type + '</apply-way>' +
        '<account>' + obj.phone + '</account>' +
        '</content>' +
        '</envelope>';
    return xml;
};

function getCodeNumber(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<command>send-register-code</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '<app>' + obj.app + '</app>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<account>' + obj.phone + '</account>' +
        '<send-way>' + obj.type + '</send-way>' +
        '</content>' +
        '</envelope>';
    return xml;
};

function register(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<command>account-register</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '<type>1</type>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>';
    // if (obj.email) {
    //     xml += '<user-name></user-name>' +
    //         '<email>' + obj.emailAddress + '</email>' +
    //         '<password>' + obj.pwd + '</password>' +
    //         '<active-way>email</active-way>';
    // } else {
    //     xml += '<user-name></user-name>' +
    //         '<mobile>' + obj.mobile + '</mobile>' +
    //         '<password>' + obj.pwd + '</password>' +
    //         '<active-way>auth-mobile</active-way>' +
    //         '<auth-code>' + obj.code + '</auth-code>';
    // };
    // xml += '</content></envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            command: 'account-register',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'user-name': '',
            [obj.email ? 'email' : 'mobile']: obj.email ? obj.email : obj.mobile,
            password: obj.pwd,
            'active-way': obj.type,
            'auth-code': obj.code
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
};
var loginMes = {
    getPosMes: getPosMes,
    login: login,
    getPwdByPhone: getPwdByPhone,
    getPwdByEmail: getPwdByEmail,
    getPwdByEmails: getPwdByEmails,
    getPwdByPhoneCode: getPwdByPhoneCode,
    getCodeNumber: getCodeNumber,
    register: register,
    baseData: baseData
};
export default loginMes;


// WEBPACK FOOTER //
// ./src/assets/js/login.js